export const GET_COUPON_LIST_REQUEST = "GET_COUPON_LIST_REQUEST";
export const GET_COUPON_LIST_SUCCESS = "GET_COUPON_LIST_SUCCESS";
export const GET_COUPON_LIST_FAIL = "GET_COUPON_LIST_FAIL";
export const GET_COUPON_LIST_RESET = "GET_COUPON_LIST_RESET";

export const APPLY_COUPON_REQUEST = "APPLY_COUPON_REQUEST";
export const APPLY_COUPON_SUCCESS = "APPLY_COUPON_SUCCESS";
export const APPLY_COUPON_FAIL = "APPLY_COUPON_FAIL";
export const APPLY_COUPON_RESET = "APPLY_COUPON_RESET";

export const REMOVE_COUPON_REQUEST = "REMOVE_COUPON_REQUEST";
export const REMOVE_COUPON_SUCCESS = "REMOVE_COUPON_SUCCESS";
export const REMOVE_COUPON_FAIL = "REMOVE_COUPON_FAIL";
export const REMOVE_COUPON_RESET = "REMOVE_COUPON_RESET";
